import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoaImageService } from './../../services/soa-image.service';
import { DatePipe } from '@angular/common';
import { ContactService } from './../../services/contact.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import { FactoringTabService } from './../../services/factoring-tab.service';
import { CompanyService } from './../../services/company.service';
import { EncrDecrService } from './../../services/encr-decr.service';

@Component({
  selector: 'app-customer-soa-list',
  templateUrl: './customer-soa-list.component.html',
  styleUrls: ['./customer-soa-list.component.css']
})
export class CustomerSOAListComponent implements OnInit {
  modalRef: BsModalRef;
  config: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };

  config1: any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };

  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  factSoaList: any = [];

  customerList: object = [];
  maxDate: Date;
  customerModel: any = {};
  customerModel1: any = {};
  FactFolderList: any;
  mobileFolderList: any = [];
  temp_var: any = false;
  delete_id: any = '';
  pdfSrc: any = '';
  soaPdfSrc: any = '';
  emailModel: any = {};
  invoice_id: any = 0;
  soaemailModel: any = {};
  soa_fact_id: any = 0;
  customer_id: any = 0;
  loaderMode: boolean = false;

  emailModal: any = true;
  emailModalError: any = false;
  downloadFactCsvSRC: any = '';


  constructor(private modalService: BsModalService,
    private _factTap2: FactoringTabService,
    private _contact: ContactService, private _soaImage: SoaImageService,
    private _router: Router, private datePipe: DatePipe,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _companyService: CompanyService,

    private SoaImageService: SoaImageService, private _factInvoice: FactoringInvoiceService, private EncrDecr: EncrDecrService) { }

  datefrom: any;
  dateto: any;
  formdata1: any = {}
  datefrom1: any;
  dateto1: any;

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.maxDate = new Date();
    var fromdate = new Date();
    var twentyMinutesLater = new Date(fromdate);
    twentyMinutesLater.setDate(twentyMinutesLater.getDate() - 60);
    this.dateto = twentyMinutesLater;
    this.datefrom = this.datePipe.transform(fromdate, 'yyyy-MM-dd');
    this.dateto = this.datePipe.transform(twentyMinutesLater, 'yyyy-MM-dd');
    this.formdata1.dateto = this.datePipe.transform(fromdate, 'MM-dd-yyyy');
    this.formdata1.datefrom = this.datePipe.transform(twentyMinutesLater, 'MM-dd-yyyy');
    this.getfactInvoiceSoa(this.datefrom, this.dateto, this.formdata1.customerid);
    this.getApiFactSoaUserList(this.datefrom, this.dateto, this.formdata1.customerid);

    this.downloadFactCsv(this.datefrom, this.dateto, this.company_id);


    this.getcustInvoiceSoa();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config1);
  }

  private static transformDate(date: Date): string {
    return new DatePipe('pt-PT').transform(date, 'MM/dd/yyyy');
  }
  getfactInvoiceSoa(datefrom, dateto, customer_id) {
    this.loaderMode = true;
    this.factSoaList = {};
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
      datefrom: datefrom,
      dateto: dateto,
      status: 'active',
    }
    this.loaderMode = false;
    ///// get mobile folder list 
    this._factTap2.getApiFactSoaUserList(customerModal)
      .subscribe(
        res => {



          // res=this.customer_id;
          this.temp_var = true;

        },
      );
  }

  getApiFactSoaUserList(datefrom, dateto, customer_id) {
    this.loaderMode = true;
    this.factSoaList = {};
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
      datefrom: datefrom,
      dateto: dateto,
      status: 'active',
    }
    this._factTap2.getFactApiSoaUserList(customerModal)
      .subscribe(
        res => {
          // console.log(res);

          this.factSoaList = res;
          // res=this.customer_id;
          this.temp_var = true;
        },
      );
  }

  onChangeCust(value) {
    this.customer_id = value;
    this.getfactInvoiceSoa(this.datefrom, this.dateto, this.formdata1.customerid);


  }



  onSelectionDone() {
    this.datefrom1 = this.datePipe.transform(this.formdata1.datefrom, 'yyyy-MM-dd hh:mm:00');
    this.dateto1 = this.datePipe.transform(this.formdata1.dateto, 'yyyy-MM-dd hh:mm:00');
    this.getfactInvoiceSoa(this.dateto1, this.datefrom1, this.formdata1.customerid);
  }
  getcustInvoiceSoa() {
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: this.customer_id,
      todate: this.formdata1.dateto,
      fromdate: this.formdata1.datefrom,
      status: 'active',
    }
    // console.log(customerModal); return false

    this._contact.getContactList(customerModal)
      .subscribe(
        res => {
          // if(res.status=='true'){
          this.formdata1['customerid'] = 0;
          this.customerList = res;
          // }
          //    console.log(res);
          //  this.customerList=res;
        },
      );

  }


  setpdfSrc(src) {
    this.pdfSrc = src;
  }


  setpdfSoaSrc(src) {
    //alert(src);
    this.soaPdfSrc = src;
  }


  getCompanyFactEmail(soa_id) {
    this.soa_fact_id = soa_id;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
    }

    this._companyService.getCompanyById(folderModel).subscribe(
      res => {
        //    console.log(res.data);  
        //  this.soaemailModel['billing_email']=res.data.fact_email;
        this.soaemailModel['billing_email'] = res.data.fact_soa_email;
        this.soaemailModel['acc_email'] = res.data.acc_email;

        //  this.soaemailModel['ccemail']=res.data.cc_email;
        this.soaemailModel['fact_id'] = res.data.fact_id;
      },
    );
  }

  sendSoaEmailToCmp() {

    var encrypted_soa_id = this.EncrDecr.set('123456$#@$^@1ERF', this.soa_fact_id);

    const soaModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      soa_id: this.soa_fact_id,
      encrypted_soa_id: encrypted_soa_id,
      email_info: this.soaemailModel,
    }
    //  console.log(soaModel); return false;
    this._factInvoice.sendSoaEmailToCmp(soaModel).subscribe(
      res => {
        //console.log(res); return false;
        this.modalRef.hide();
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab2');
        });
      },
    );


  }
  getCustomerEmail(customer_id, invoice_id) {
    this.emailModalError = false;
    /// console.log(customer_id);console.log(invoice_id);
    this.invoice_id = invoice_id;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {
        // console.log(res.data);
        this.emailModel = res.data;
      },
    );
  }
  sendEmailToCust() {
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      invoice_id: this.invoice_id
    }


    this._factInvoice.sendEmailToCustomer(folderModel).subscribe(
      res => {

        this.modalRef.hide();
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
        this.emailModal = false;
        this._router.navigateByUrl('/redirect').then(() => {
          this._router.navigateByUrl('/factoring/factoring-tab2');
        });
      },
    );

    if (this.emailModal) {
      const rload = this;
      setTimeout(function () { rload.emailModalError = true; }, 1500);
    }
  }

  downloadFactCsv(datefrom, dateto, company_id) {
    this.loaderMode = true;
    this.factSoaList = {};
    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: company_id,
      //customer_id : customer_id, 
      datefrom: datefrom,
      dateto: dateto,
      status: 'active',
    }
    this.loaderMode = false;
    ///// get mobile folder list 
    this._factTap2.downloadFactoringSoaList(customerModal)
      .subscribe(
        res => {

          // console.log(res);

          this.downloadFactCsvSRC = res.url;
          // this.downloadFactCsvSRC='https://soav3.mybizpad.com/rest_api/uploads/Sample_csv_download.csv';



        },
      );


  }
  checkUncheckAll($event) {
    if ($event.target.checked == true) {
      $('.checkUncheckAll').prop("checked", true);
    } else {
      $('.checkUncheckAll').prop("checked", false);
    }
  }

}
